import React, {FunctionComponent, useEffect, useState} from 'react';
import {MerklisteProduktKarte} from '@juris/api-gen';
import {useApiContext, useMerklisteContext} from 'Context';
import {ProduktItem} from './ProduktItem';

export const ProduktListe: FunctionComponent = () => {
    const {apiObjects} = useApiContext();
    const {merkliste} = useMerklisteContext();
    const [produkte, setProdukte] = useState<Array<MerklisteProduktKarte>>([]);

    useEffect(() => {
        apiObjects.merklisteController
            .ermittleProduktInformationenVonSolRUsingPOST({cmsIds: merkliste.produkte || []})
            .then(produkte => setProdukte(produkte));
    }, [apiObjects, setProdukte, merkliste]);

    return <>
        {produkte.map((produkt, index) => <ProduktItem key={index} {...produkt} />)}
        {!produkte.length && <div className='textblock'>
            <h2>0 Produkte auf der Merkliste</h2>
            <p>Sie benötigen Orientierung? Nutzen Sie unser Online-Beratungstool und finden Sie die passende Lösung für
                Ihre individuellen Anforderungen.</p>
            <a href={'/jportal/nav/produkte/index.jsp#/fragen/branche'}
               className='text-icon-link text-icon-link--link'>
                <span className='text-icon-link__icon'/>
                <span className='text-icon-link__text'>Zum Online-Beratungstool</span>
            </a>
        </div>}
    </>;
};